"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NAMESPACE = void 0;

var _reducers = _interopRequireDefault(require("./reducers"));

var _epics = _interopRequireDefault(require("./epics"));

var _routes = _interopRequireDefault(require("./routes"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var NAMESPACE = 'blogs';
exports.NAMESPACE = NAMESPACE;
var _default = {
  route: _UrlPathParams.BLOGS,
  reducer: _reducers.default,
  routes: _routes.default,
  rootEpic: _epics.default
};
exports.default = _default;